import clsx from "clsx";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ImagePicker from "../../../components/ImagePicker";
import { Input } from "../../../components/Input";
import ModalAction from "../../../components/ModalAction";
import ModalSkeleton from "../../../components/ModalSkeleton";
import { toast } from "react-toastify";

import { paymentReceivedSchema } from "../../../schema";
import LeftSide from "../../../components/LeftSide";
import classes from "./PaymentReceived.module.css";
import Dropdown from "../../../components/Dropdown";
import {
  InvoiceIcon,
  DiscountIcon,
  NoteIcon,
  ReceivePaymentIcon,
} from "../../../constant";
import { paymentMethods } from "../../../data";
import ShowCalculation from "../../../components/ShowCalculation";
import { formatNumberWithCommas } from "../../../helpers";

const initialValues = {
  discount: "",
  totalAmount: "",
  refundAmount: "",
  paymentReceived: "",
  attachment: null,
};

const PaymentReceivedModal = ({
  label = "Payment Received",
  show,
  setShow,
  data,
  onSubmit,
}) => {
  const formik = useFormik({
    initialValues,
    validationSchema: paymentReceivedSchema,
    onSubmit: (values, { resetForm }) => {
      console.log("params values", values);
      const params = {
        bookingId: data?.bookingId,
        paymentModeId: values?.paymentMethod,
        discount: values?.discount || 0,
        collectedAmount: values?.paymentReceived || 0,
        attachment: values?.attachment,
      };

      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });

  console.log("data ==> payment received", data);

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const totalAmount =
    Number(values?.totalAmount) - Number(values?.discount || 0);
  const remainingAmount =
    Number(values?.totalAmount) -
    Number(values?.discount || 0) -
    Number(values?.paymentReceived || 0);
  useEffect(() => {
    setFieldValue("paymentMethod", paymentMethods[0]?.value);
    if (data) {
      const collectedAmount = data?.bookingCollectedAmount || 0;
      // setFieldValue("discount", data?.bookingDiscountAmount || 0);
      setFieldValue("totalAmount", data?.bookingNetAmount - collectedAmount);
    }
  }, [data]);
  return (
    <>
      <ModalSkeleton width="700px" show={show} setShow={setShow} title={label}>
        <form onSubmit={handleSubmit}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <Input
                type="number"
                leftIcon={
                  <LeftSide
                    right={"Rs."}
                    icon={
                      <DiscountIcon
                        className={clsx(classes.leftIcon, classes.iconSize)}
                        disabled={true}
                      />
                    }
                  />
                }
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                labelStyle={{ fontSize: "16px" }}
                label={"Total Discount"}
                placeholder="Enter Discount"
                value={values?.discount}
                onChange={(e) => {
                  const discount = Number(e);
                  const totalAmount = Number(values?.totalAmount);

                  if (discount > totalAmount) {
                    toast.warn("Discount cannot be greater than total amount");
                    return;
                  }
                  handleChangeWithTouch("discount")(discount);
                }}
              />
            </Col>

            <Col md={6}>
              <Input
                disabled={true}
                isOptional={true}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                leftIcon={<NoteIcon />}
                labelStyle={{ fontSize: "16px" }}
                label={"Total Payment"}
                placeholder="Enter Total Payment"
                value={totalAmount}
                onChange={handleChangeWithTouch("totalAmount")}
              />
              <ShowCalculation
                label={"Remaining Amount"}
                value={`Rs. ${formatNumberWithCommas(remainingAmount)}`}
              />{" "}
            </Col>
            <Col md={6}>
              <Input
                icon={
                  <ReceivePaymentIcon
                    className={clsx(classes.leftIcon, classes.iconSize)}
                    disabled={true}
                  />
                }
                isOptional={true}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                leftIcon={<NoteIcon />}
                labelStyle={{ fontSize: "16px" }}
                label={"Payment Received"}
                placeholder="Enter Total Payment Received"
                value={values?.paymentReceived}
                onChange={(e) => {
                  const payment = Number(e);
                  const maxAllowed = totalAmount;

                  if (payment > maxAllowed) {
                    toast.warn(
                      "Payment received cannot be greater than remaining amount"
                    );
                    return;
                  }
                  handleChangeWithTouch("paymentReceived")(payment);
                }}
                errorText={touched?.paymentReceived && errors?.paymentReceived}
              />
            </Col>
            {label === "Payment Received" && (
              <Col md={6}>
                <Dropdown
                  icon={
                    <InvoiceIcon
                      className={clsx(classes.leftIcon, classes.iconSize)}
                    />

                    // <CashIcon
                    //   className={clsx(classes.leftIcon, classes.iconSize)}
                    // />
                  }
                  options={paymentMethods?.filter((data)=>data?.value !== 0)}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Payment Mode"}
                  placeholder="Select Payment Mode"
                  value={values?.paymentMethod}
                  onChange={handleChangeWithTouch("paymentMethod")}
                  errorText={touched?.paymentMethod && errors?.paymentMethod}
                />
              </Col>
            )}
            {label === "Confirmation" && values?.paymentReceived > 0 && (
              <Col md={6}>
                <Dropdown
                  icon={
                    <InvoiceIcon
                      className={clsx(classes.leftIcon, classes.iconSize)}
                    />

                    // <CashIcon
                    //   className={clsx(classes.leftIcon, classes.iconSize)}
                    // />
                  }
                  options={paymentMethods}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Payment Mode"}
                  placeholder="Select Payment Mode"
                  value={values?.paymentMethod}
                  onChange={handleChangeWithTouch("paymentMethod")}
                  errorText={touched?.paymentMethod && errors?.paymentMethod}
                />
              </Col>
            )}
            <Col md={12}>
              <ImagePicker
                value={values?.attachment}
                onChange={handleChangeWithTouch("attachment")}
              />
            </Col>
          </Row>

          <ModalAction type="submit" onCancel={() => setShow(false)} />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default PaymentReceivedModal;
